export default __webpack_public_path__ + "static/media/about_text_en.93233fd3.png";